/**
 * The store-context super properties every analytics event should carry, in
 * one place so pages/_app.js and any page that already has its own
 * server-fetched `store` (order confirmation, cart) can register them without
 * each keeping its own drifting copy of the field mapping.
 * @param {Object} store
 * @returns {Object}
 */
export const buildStoreSuperProperties = (store) => ({
  store_id: store?.id ?? store?._id,
  store_subdomain: store?.subdomain ?? store?.subDomain,
  store_name: store?.storeName,
  store_cohort: store?.cohort,
  store_proplan_active: store?.proplan?.isActive ?? false,
});
